import { Component, Inject, OnInit } from "@angular/core";
import { ORGANISATION_PURPOSE_VISION_PAGE, TEAM_DASHBOARD_PAGE } from "@common/page-route-providers";
import { IAdaptRoute } from "@common/route/page-route-builder";
import { IAdaptLinkObject } from "@common/route/route.service";
import { SearchService } from "@org-common/lib/search/search.service";
import { SearchRowBaseComponent } from "@org-common/lib/search/search-row-base.component";
import { Observable } from "rxjs";
import { IPurposeVisionSearchResult, PurposeVisionType } from "../search-results.interface";

@Component({
    selector: "adapt-search-row-purpose-vision",
    templateUrl: "./search-row-purpose-vision.component.html",
    standalone: false,
})
export class SearchRowPurposeVisionComponent extends SearchRowBaseComponent<IPurposeVisionSearchResult> implements OnInit {
    public href$?: Observable<IAdaptLinkObject>;

    public constructor(
        protected searchService: SearchService,
        @Inject(ORGANISATION_PURPOSE_VISION_PAGE) private organisationPurposeVisionRoute: IAdaptRoute<any>,
        @Inject(TEAM_DASHBOARD_PAGE) private teamDashboardPageRoute: IAdaptRoute<{ teamId: number }>,
    ) {
        super(searchService);
    }

    public ngOnInit() {
        super.ngOnInit();

        this.href$ = this.result.teamId
            ? this.teamDashboardPageRoute.getRouteObject({ teamId: this.result.teamId })
            : this.organisationPurposeVisionRoute.getRouteObject();

        this.matches = this.excludeNameBreadcrumb(this.result.results);
    }

    public get title() {
        switch (this.result.innerType) {
            case PurposeVisionType.Purpose:
                return "Purpose";
            case PurposeVisionType.Vision:
                return "Vision";
            default:
                return "Unknown";
        }
    }

    public get icon() {
        switch (this.result.innerType) {
            case PurposeVisionType.Purpose:
                return "fal fa-fw fa-compass";
            case PurposeVisionType.Vision:
                return "fal fa-fw fa-binoculars";
            default:
                return "fal fa-fw";
        }
    }
}
